// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__H25mB","container":"Footer_container__psxIT"};